import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';
import { Close } from '@styled-icons/material';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled, colors } from '@naf-simba/theme';
import { Input } from '@naf/input';
import styled from '@emotion/styled';
import { Chevron } from '@components/MembershipBox/Styles';

export const Background = styled.div`
  background-color: ${colors.secondary[900]};
  padding: ${spacing.space24};
`;

export const Container = styled.div`
  position: relative;
  max-width: 512px;
  margin: ${spacing.space8} 0 ${spacing.space24};
  display: flex;
  flex-direction: column;
  overflow: visible;
  background-color: ${colors.secondary[900]};
`;

export const DropdownButton = styled.button`
  text-align: left;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 11;
  color: ${nafColor.signature.black};
`;

export const DropdownMenu = styled.div`
  position: absolute;
  z-index: 9999;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: ${spacing.space16} ${spacing.space8} 0;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
  width: 100%;
  margin-top: ${spacing.space56};

  @media (max-width: ${breakpoints.m}) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100vw - ${spacing.space48});
    height: 80vh;
    max-height: 80vh;
    border-radius: 0.5rem;
    margin-top: ${spacing.space24};
  }
`;

export const ModelHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    background: #f3f4f6;
  }
`;

export const SeasonHeader = styled.div`
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    background: #f9fafb;
  }
`;

export const VariantsContainer = styled.div`
  padding-left: 1rem;
`;

export const VariantLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
`;

export const StyledChevron = styled(Chevron)`
  height: 20px;
  width: 20px;
`;

export const SelectedVariantsContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: ${spacing.space8};
`;

export const SelectedVariantBanner = styled.div`
  padding: ${spacing.space8} ${spacing.space16};
  background: #f2f2f2;
  border-radius: ${spacing.space8};
  height: fit-content;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseButton = styled(Close)`
  cursor: pointer;
  flex-shrink: 0;
`;

export const BrandName = styled.span`
  font-weight: 500;
`;

export const SearchBar = styled(Input)`
  width: calc(100% - ${spacing.space16});
  margin: ${spacing.space8};
`;

export const StyledButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  background-color: white;
  margin-top: auto;
`;

export const StyledButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    width: `calc(100% + ${theme.spacing(4)})`,
    margin: `0 -${theme.spacing(2)}`,
  },
}));

export const DropdownBackdrop = styled.div`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
  }
`;
